import React, { PureComponent } from 'react';
import ReactModal from 'react-modal';
import CloseIcon from '../CloseIcon';
import {
  StyledButton,
  StyledTitle,
  StyledReactModal,
  StyledWrapper,
} from './Modal.style';

export default class Modal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };

    ReactModal.setAppElement('body');

    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.handleAfterOpen = this.handleAfterOpen.bind(this);
    this.handleAfterClose = this.handleAfterClose.bind(this);
  }

  componentDidMount() {
    const { getOpenFn, getCloseFn } = this.props;

    getOpenFn(this.onOpen);
    getCloseFn?.(this.onClose);
  }

  handleAfterOpen() {
    const { onAfterOpen } = this.props;

    onAfterOpen?.();
  }

  onOpen() {
    this.setState({ isOpen: true });
  }

  onClose() {
    this.setState({ isOpen: false });
  }

  handleAfterClose() {
    const { onAfterClose } = this.props;
    onAfterClose?.();
  }

  render() {
    const {
      children,
      closeWord,
      customStyle,
      fullPage,
      portalClassName,
      settings,
      title,
      className,
    } = this.props;
    const { isOpen } = this.state;
    const bodyStyle = settings.style.body;

    return (
      <StyledReactModal
        className={className}
        closeTimeoutMS={300}
        isOpen={isOpen}
        onRequestClose={this.onClose}
        onAfterClose={this.handleAfterClose}
        onAfterOpen={this.handleAfterOpen}
        fullPage={fullPage}
        style={{
          overlay: {
            ...bodyStyle,
            borderRadius: '4px',
          },
          content: {
            ...bodyStyle,
            ...settings.style.boxShadow,
            ...customStyle,
          },
        }}
        appElement={document.querySelector('.main-panel')}
        portalClassName={portalClassName}
      >
        {title && (
          <StyledTitle
            styled={settings.style.title}
          >
            {title}
          </StyledTitle>
        )}

        <StyledWrapper>{children}</StyledWrapper>

        {closeWord ? (
          <StyledButton
            onClick={this.onClose}
          >
            {closeWord}
          </StyledButton>
        ) : (
          <CloseIcon onClick={this.onClose} />
        )}
      </StyledReactModal>
    );
  }
}
